import Auth from '../api/auth';

const parseErrorCode = error => {
  // Admin-driven blocks on a live session → bounce to the branded dead-end
  // page instead of surfacing a random error toast / broken dashboard:
  //   • account_paused      — per-user pause (EnforceAccountNotPaused concern)
  //   • account_suspended   — whole-agency block (EnsureCurrentAccountHelper)
  //   • account_deactivated — per-agent deactivation, #199 (EnsureCurrentAccountHelper)
  // role param picks the right copy (agent vs admin).
  const data = error?.response?.data;
  if (
    data?.code === 'account_paused' ||
    data?.code === 'account_suspended' ||
    data?.code === 'account_deactivated'
  ) {
    const role = data.paused_role || 'admin';
    const pageByCode = {
      account_suspended: 'account-suspended',
      account_deactivated: 'account-deactivated',
    };
    const page = pageByCode[data.code] || 'account-paused';
    window.location = `/app/${page}?role=${role}`;
    return new Promise(() => {}); // never resolve — page is navigating away
  }
  return Promise.reject(error);
};

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
